import * as React from "react";
import { useTranslation } from "react-i18next";
import { InputOptionalInfo, FormikFormGroup } from "components/common";
const TitleFormGroup = ({ wrapperClassName = void 0, labelClassName = void 0 }) => {
  const { t } = useTranslation("enterprise_search");
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "title",
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("title_form_group.title"), " ", /* @__PURE__ */ React.createElement(InputOptionalInfo, null)),
      labelClassName,
      wrapperClassName,
      help: t("title_form_group.help")
    }
  );
};
export default TitleFormGroup;
